<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1_3652)">
      <path
        d="M8.00005 0.916656C3.78805 0.916656 0.360718 3.74066 0.360718 7.21132C0.373287 8.04525 0.568345 8.8663 0.93218 9.61678C1.29601 10.3673 1.8198 11.0289 2.46672 11.5553L0.944051 14.6C0.918431 14.6508 0.90626 14.7074 0.9087 14.7643C0.91114 14.8212 0.928109 14.8765 0.957989 14.9249C0.987869 14.9734 1.02966 15.0134 1.07939 15.0411C1.12912 15.0689 1.18512 15.0834 1.24205 15.0833C1.29064 15.0831 1.33861 15.0724 1.38272 15.052L5.46672 13.1513C6.29036 13.3877 7.14318 13.5068 8.00005 13.5053C12.2121 13.5053 15.6394 10.6813 15.6394 7.21132C15.6394 3.74132 12.2121 0.916656 8.00005 0.916656ZM4.63938 8.24999C4.4416 8.24999 4.24826 8.19134 4.08381 8.08146C3.91937 7.97158 3.79119 7.8154 3.71551 7.63267C3.63982 7.44995 3.62001 7.24888 3.6586 7.0549C3.69718 6.86092 3.79243 6.68274 3.93228 6.54288C4.07213 6.40303 4.25031 6.30779 4.44429 6.2692C4.63828 6.23062 4.83934 6.25042 5.02207 6.32611C5.20479 6.4018 5.36097 6.52997 5.47085 6.69442C5.58074 6.85887 5.63938 7.05221 5.63938 7.24999C5.63938 7.51521 5.53403 7.76956 5.34649 7.9571C5.15895 8.14463 4.9046 8.24999 4.63938 8.24999ZM8.00005 6.24999C8.19783 6.24999 8.39117 6.30864 8.55562 6.41852C8.72007 6.5284 8.84824 6.68458 8.92393 6.86731C8.99962 7.05003 9.01942 7.2511 8.98084 7.44508C8.94225 7.63906 8.84701 7.81724 8.70716 7.9571C8.56731 8.09695 8.38912 8.19219 8.19514 8.23078C8.00116 8.26936 7.80009 8.24956 7.61737 8.17387C7.43464 8.09818 7.27846 7.97001 7.16858 7.80556C7.0587 7.64111 7.00005 7.44777 7.00005 7.24999C7.00005 6.98477 7.10541 6.73042 7.29294 6.54288C7.48048 6.35535 7.73483 6.24999 8.00005 6.24999ZM11.3334 8.24999C11.1356 8.24999 10.9423 8.19134 10.7778 8.08146C10.6134 7.97158 10.4852 7.8154 10.4095 7.63267C10.3338 7.44995 10.314 7.24888 10.3526 7.0549C10.3912 6.86092 10.4864 6.68274 10.6263 6.54288C10.7661 6.40303 10.9443 6.30779 11.1383 6.2692C11.3323 6.23062 11.5333 6.25042 11.7161 6.32611C11.8988 6.4018 12.055 6.52997 12.1649 6.69442C12.2747 6.85887 12.3334 7.05221 12.3334 7.24999C12.3334 7.51521 12.228 7.76956 12.0405 7.9571C11.853 8.14463 11.5986 8.24999 11.3334 8.24999Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3652">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: "ChatIcon"
  }
</script>